import type { Bbox } from "./projectBbox";

/**
 * Where the listing map opens before (or instead of) fitting to projects.
 * Chosen from the user's unit system: metric users are our Australian
 * customers, imperial users are in the United States. [west, south, east, north].
 */
export const HOME_REGIONS = {
  metric: { name: "Australia", bounds: [112.9, -43.7, 153.7, -10.5] as Bbox },
  imperial: { name: "United States", bounds: [-125.0, 24.5, -66.9, 49.4] as Bbox },
} as const;

export function homeBoundsFor(unitSystem: "metric" | "imperial" | null | undefined): Bbox {
  return (unitSystem === "imperial" ? HOME_REGIONS.imperial : HOME_REGIONS.metric).bounds;
}

/**
 * True when fitting these bounds would show most of the globe (projects on
 * more than one continent). A view like that tells nobody anything, so the
 * home region is shown instead.
 */
export function isGlobeSpanning(b: Bbox): boolean {
  return b[2] - b[0] > 90 || b[3] - b[1] > 60;
}

/** Centre and a rough zoom for constructing a map over `b`. */
export function cameraFor(b: Bbox): { center: { lat: number; lng: number }; zoom: number } {
  const span = Math.max(Math.abs(b[2] - b[0]), Math.abs(b[3] - b[1]), 1e-6);
  return {
    center: { lat: (b[1] + b[3]) / 2, lng: (b[0] + b[2]) / 2 },
    zoom: Math.min(12, Math.max(1, Math.floor(Math.log2(360 / span)))),
  };
}
